import { render, staticRenderFns } from "./CommissionActionMassApprove.vue?vue&type=template&id=a78ae3f8&"
import script from "./CommissionActionMassApprove.vue?vue&type=script&lang=ts&"
export * from "./CommissionActionMassApprove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports